import { render, staticRenderFns } from "./CartaoInformacoes.vue?vue&type=template&id=29bbf306&scoped=true"
import script from "./CartaoInformacoes.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoes.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoes.vue?vue&type=style&index=0&id=29bbf306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bbf306",
  null
  
)

export default component.exports